import { type ColumnDef } from '@tanstack/react-table';
import { type ReactNode } from 'react';

import { formatarDataHora } from '@/lib/formato';
import { type MetaColuna } from '@/ui/components/tabela-dados';
import { Badge } from '@/ui/primitives/badge';
import { type UsuarioResumo } from '@fiscoai/contracts';

const meta = (m: MetaColuna) => m;

/** Colunas de Pessoas; a do perfil de plataforma é texto ou seletor, conforme quem vê. */
export const colunasUsuarios = (
  celulaPerfil: (usuario: UsuarioResumo) => ReactNode,
): ColumnDef<UsuarioResumo>[] => [
  {
    id: 'nome',
    header: 'Pessoa',
    cell: ({ row }) => (
      <span className="grid leading-tight">
        <span className="font-medium">{row.original.nome}</span>
        <span className="text-xs text-texto-fraco">{row.original.email}</span>
      </span>
    ),
  },
  {
    id: 'perfil',
    header: 'Perfil na plataforma',
    cell: ({ row }) => celulaPerfil(row.original),
  },
  {
    id: 'empresas',
    header: 'Empresas',
    meta: meta({ alinhar: 'direita', largura: '7rem' }),
    cell: ({ row }) => <span className="tabular">{row.original.quantidadeEmpresas}</span>,
  },
  {
    id: 'acesso',
    header: 'Último acesso',
    meta: meta({ largura: '11rem' }),
    cell: ({ row }) => (
      <span className="tabular text-texto-suave">
        {formatarDataHora(row.original.ultimoLoginEm)}
      </span>
    ),
  },
  {
    id: 'situacao',
    header: 'Situação',
    meta: meta({ largura: '7rem' }),
    cell: ({ row }) =>
      row.original.ativo ? <Badge tom="sucesso">Ativo</Badge> : <Badge tom="perigo">Inativo</Badge>,
  },
];
